import React, {Component} from 'react';
import styles from 'css/screens/result.css';

/**
 * Development：ファクト開発
 */
export default class Development extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <div className={styles.advice}>
        <h2>御社が強化すべきは<span>ファクト開発</span>です。</h2>
        <p>
          機能や技術だけで差別化しようとしていませんか？<br />
          世の中の時流や顧客のニーズを把握し、<br />
          市場創造に必要なファクト開発を行いましょう。<br />
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/result/advice/development.js